
import { defineComponent, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'
import { browsedHistory } from '@/api/profile'

export default defineComponent({
  props: {
    userInfoList: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    const store = useStore()
    const recentHistories = ref([] as any)
    const restHistories = ref([] as any)
    const isShowAll = ref(false)
    const asyncGetBrowsedHistory = async () => {
      const res = await browsedHistory()
      if (res.status) {
        recentHistories.value = res.data.recentHistories
        restHistories.value = res.data.restHistories
        if (
          res.data.restHistories.length === 0 ||
          res.data.recentHistories.length === 0
        ) {
          isShowAll.value = true
          recentHistories.value =
            res.data.recentHistories.length > 0
              ? res.data.recentHistories
              : res.data.restHistories
        }
      }
    }
    const showDetail = (conceptId: string) => {
      const dataSourceName = (
        document.getElementById('dicName') as HTMLInputElement
      ).value
      const item = store.state.dataSourceList.filter(
        (item) => item.describe === dataSourceName
      )[0]
      router.push(`/conceptDetail/${conceptId}/${item.name}/${item.version}`)
    }
    onMounted(() => {
      asyncGetBrowsedHistory()
    })
    return {
      showDetail,
      store,
      asyncGetBrowsedHistory,
      recentHistories,
      restHistories,
      isShowAll,
    }
  },
})
